module.exports = __webpack_public_path__ + "static/q10-2795abf88a5c5910f6ff77239fc25ee8.png";